<script lang="ts">
export default defineComponent({
  inheritAttrs: false,
  props: {
    href: {
      type: String,
      required: false,
      default: null,
    },
    as: {
      type: String,
      required: false,
      default: null,
    },
    variant: {
      type: String,
      required: false,
      default: 'primary',
    },
    size: {
      type: String,
      required: false,
      default: 'default',
    },
  },
  setup() {
    return {
      NuxtLink: resolveComponent('NuxtLink'),
    };
  },
});
</script>

<template>
  <component
    :is="as ? as : (href ? NuxtLink : 'button')"
    :to="as !== 'a' ? href : undefined"
    :href="as === 'a' ? href : undefined"
    v-bind="$attrs"
    class="btn"
    :class="{
      'btn-primary': variant === 'primary',
      'btn-secondary': variant === 'secondary',
      'btn-ghost': variant === 'ghost',
      'h-10 px-4 py-2': size === 'default',
      'h-8 px-3 text-xs': size === 'sm',
      'h-12 px-8 text-base!': size === 'lg',
      'h-9 w-9 text-base!': size === 'icon',
    }"
  >
    <slot />
  </component>
</template>
